import { Pipe, PipeTransform } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";

interface NotificationSubjectView {
    SubjectType: string;
    SubjectId: number;
}

/**
 * Renders the business record a notification points at, in the reader's language.
 *
 * The stored `SubjectType` is the producer's internal name ("Wallet", "PickupBooking"), which is
 * what used to leak into the inbox as "Wallet #12". Unknown types keep their raw value rather than
 * disappearing — a missing dictionary entry has to stay visible so it can be added.
 */
@Pipe({ name: "notificationSubject", standalone: true, pure: false })
export class NotificationSubjectPipe implements PipeTransform {
    constructor(private readonly transloco: TranslocoService) {}

    transform(item: NotificationSubjectView | null | undefined): string {
        if (!item) return "";

        const type = this.typeLabel(item.SubjectType);
        if (!type) return "";
        if (!item.SubjectId) return type;

        return this.transloco.translate("notificationInbox.object-ref", { type, id: item.SubjectId });
    }

    /** Localized label for a raw `SubjectType`, falling back to the raw value. */
    typeLabel(subjectType: string | null | undefined): string {
        const raw = String(subjectType ?? "").trim();
        if (!raw) return "";

        const key = `notificationInbox.subject-type.${raw}`;
        const translated = this.transloco.translate(key);
        return translated && translated !== key ? translated : raw;
    }
}
